function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { getMediaTypeFromUrl } from '../utils/media';
/**
 * 미디어 유틸리티 훅
 * 
 * 미디어 관련 여러 유틸리티 함수를 제공합니다.
 * 
 * @returns 미디어 유틸리티 함수 모음
 */ export function useMediaUtils() {
    // URL 패턴으로 숏폼 비디오 감지
    var isShortFormByUrl = function(url) {
        var shortFormPatterns = [
            'shorts',
            'reels',
            'tiktok',
            'vertical',
            'portrait',
            'instagram.com/reel',
            'vm.tiktok',
            'youtube.com/shorts'
        ];
        return shortFormPatterns.some(function(pattern) {
            return url.toLowerCase().includes(pattern);
        });
    };
    // 미디어가 비디오인지 확인
    var isMediaVideo = function(mediaUrl, videos, shortFormVideos) {
        return videos.includes(mediaUrl) || shortFormVideos.includes(mediaUrl);
    };
    // 미디어가 숏폼 비디오인지 확인
    var isMediaShortForm = function(mediaUrl, shortFormVideos) {
        return shortFormVideos.includes(mediaUrl) || isShortFormByUrl(mediaUrl);
    };
    // 미디어가 일반 비디오인지 확인
    var isMediaNormalVideo = function(mediaUrl, videos, shortFormVideos) {
        return videos.includes(mediaUrl) && !shortFormVideos.includes(mediaUrl) && !isShortFormByUrl(mediaUrl);
    };
    // 미디어 타입 감지
    var getMediaDisplayType = function(mediaUrl) {
        return getMediaTypeFromUrl(mediaUrl);
    };
    // 미디어 배열 최적화
    var optimizeMediaOrder = function(normalVideos, shortFormVideos, images) {
        // 미디어 우선순위: 1. 일반 비디오 2. 숏폼 비디오 3. 이미지
        return _to_consumable_array(normalVideos).concat(_to_consumable_array(shortFormVideos), _to_consumable_array(images));
    };
    // 그리드 레이아웃 유형 결정
    var determineGridLayoutType = function(displayMedia, normalVideos, isComplexMixedMedia) {
        var isThreeItemsWithNormalVideo = displayMedia.length === 3 && normalVideos.includes(displayMedia[0]);
        var hasFourItemsWithNormalVideo = displayMedia.length === 4 && displayMedia.some(function(media) {
            return normalVideos.includes(media);
        });
        if (displayMedia.length === 1) {
            return "single";
        } else if (displayMedia.length === 2) {
            return "two-cols";
        } else if (displayMedia.length === 3) {
            if (isThreeItemsWithNormalVideo || isComplexMixedMedia && normalVideos.includes(displayMedia[0])) {
                return "one-plus-two";
            } else {
                return "three-cols";
            }
        } else {
            if (hasFourItemsWithNormalVideo) {
                return "one-plus-three";
            } else {
                return "two-by-two";
            }
        }
    };
    // 그리드 템플릿 클래스 결정
    var getGridTemplateClass = function(layoutType) {
        switch(layoutType){
            case "single":
                return "grid-cols-1";
            case "two-cols":
                return "grid-cols-2";
            case "three-cols":
                return "grid-cols-3";
            case "one-plus-two":
                return "grid-cols-1 md:grid-cols-2";
            case "one-plus-three":
                return "grid-cols-1 md:grid-cols-2";
            case "two-by-two":
                return "grid-cols-2";
            default:
                return "grid-cols-2";
        }
    };
    return {
        isShortFormByUrl: isShortFormByUrl,
        isMediaVideo: isMediaVideo,
        isMediaShortForm: isMediaShortForm,
        isMediaNormalVideo: isMediaNormalVideo,
        getMediaDisplayType: getMediaDisplayType,
        optimizeMediaOrder: optimizeMediaOrder,
        determineGridLayoutType: determineGridLayoutType,
        getGridTemplateClass: getGridTemplateClass
    };
}
export default useMediaUtils;
